(() => {
  const HEADER_GAP = 12;

  function headerOffset() {
    const raw = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue("--header-height")
    );
    return (Number.isNaN(raw) ? 50 : raw) + HEADER_GAP;
  }

  function pinHeroTrack(track) {
    const head = track.firstElementChild;
    if (!head) return;

    const trackHeight = track.clientHeight;
    const headHeight = head.offsetHeight;
    if (trackHeight < 2 || headHeight < 1) return;

    const minTop = headerOffset();
    const maxTop = Math.max(minTop, window.innerHeight - headHeight - 32);
    const pin = Math.min(Math.max(minTop, (trackHeight - headHeight) / 2), maxTop);
    track.style.setProperty("--scroll-heading-pin", `${Math.round(pin)}px`);
  }

  function pinHeroTracks() {
    document.querySelectorAll(".scroll-heading-track--middle").forEach(pinHeroTrack);
  }

  function initSlideHeads(section) {
    const swiperEl = section.querySelector(".swiper");
    const heads = section.querySelectorAll("[data-slide-head]");
    if (!swiperEl || !heads.length || typeof Swiper === "undefined") return;

    const showHead = (index) => {
      heads.forEach((head, i) => {
        head.hidden = i !== index;
      });
      const track = section.querySelector(".scroll-heading-track--middle");
      if (track) pinHeroTrack(track);
    };

    const swiper = swiperEl.swiper;
    if (!swiper) return;

    showHead(swiper.realIndex);
    swiper.on("slideChange", () => showHead(swiper.realIndex));
  }

  function init() {
    pinHeroTracks();
    document
      .querySelectorAll(".image-slide-hero[data-scroll-heading-section]")
      .forEach(initSlideHeads);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", pinHeroTracks);
  window.addEventListener("resize", pinHeroTracks);
  document.fonts?.ready?.then(pinHeroTracks);

  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver(() => pinHeroTracks());
    const observe = () => {
      document.querySelectorAll(".scroll-heading-track--middle").forEach((track) => {
        observer.observe(track);
      });
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", observe);
    } else {
      observe();
    }
  }

  document.addEventListener("shopify:section:load", init);
})();
